import GetReferentLookupRequestModelBase from '../_generated/modelBases/get-referent-lookup-request-model-base';

export default class GetReferentLookupRequestModel extends GetReferentLookupRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
